import { Status } from './../../shared/constants/status.enum';
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { environment } from "../../../environments/environment";
import { SharedModule } from "../../shared/modules/shared.module";
import { ApiConvertError } from '../../types/api.error.type';
import { CommonModule } from '@angular/common';

@Component({
  selector: "app-migration-fail",
  imports: [CommonModule, SharedModule, TranslatePipe],
  standalone: true,
  templateUrl: "./migration-fail.component.html",
  styleUrl: "./migration-fail.component.scss",
})
export class MigrationFailComponent {
  @Input() error: ApiConvertError = {}
  @Output() handleTryAgain = new EventEmitter<{ status: Status }>();

  protected mailToLink = `mailto:${environment.supportEmail}`;

  handleContactUs = () => {
    window.location.href = this.mailToLink;
  };

  onTryAgain = () => {
    this.handleTryAgain.emit({ status: Status.NEW })
  };

  errorKeys(obj: ApiConvertError): string[] {
    return Object.keys(obj).filter(
      key => Array.isArray(obj[key]) ? (obj[key] as string[]).length > 0 : false
    );
  }

  capitalize(str: string): string {
    if (!str) return str;

    let capitalized = str.charAt(0).toUpperCase() + str.slice(1);

    if (!capitalized.endsWith('s')) {
      const esEndings = ['s', 'x', 'z', 'ch', 'sh'];
      const lower = str.toLowerCase();

      if (esEndings.some(e => lower.endsWith(e))) {
        capitalized += 'es';
      } else {
        capitalized += 's';
      }
    }

    return capitalized;
  }
}
